'use strict';

/**
 * PlansheetSort
 * -------------
 * The one ordering for the cross-tenant plan-sheet lists (WI #339): pinned first, then most recently
 * visited, then alphabetical by name. Pure and dependency-free so the same comparator runs on the
 * server (GET /1.0/Account/Tenants) and in the browser (the home view and the account switcher). Sharing
 * it means a pin toggled locally re-sorts exactly the way a refetch from the server would, with no drift.
 *
 * Each item is expected to carry { Pinned:bool, LastVisited:isoString|null, CustomerName:string }.
 */

function _time(pValue)
{
	if (!pValue) { return 0; }
	let tmpMs = new Date(pValue).getTime();
	return isNaN(tmpMs) ? 0 : tmpMs;
}

// The comparator, exposed for callers that want to sort in place with their own array method.
function comparePlansheets(pA, pB)
{
	if (pA.Pinned && !pB.Pinned) { return -1; }
	if (!pA.Pinned && pB.Pinned) { return 1; }
	let tmpTA = _time(pA.LastVisited);
	let tmpTB = _time(pB.LastVisited);
	if (tmpTA !== tmpTB) { return tmpTB - tmpTA; }
	return String(pA.CustomerName || '').localeCompare(String(pB.CustomerName || ''));
}

// Sort a list of plan-sheet blobs in place (and return it) by the pinned-then-recency-then-name order.
function sortPlansheets(pList)
{
	let tmpList = Array.isArray(pList) ? pList : [];
	tmpList.sort(comparePlansheets);
	return tmpList;
}

module.exports = { sortPlansheets, comparePlansheets };
